import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Wellcome from './routes/Wellcome';
import Signup from './routes/Signup';
import Login from './routes/Login';
import Dashboard from './routes/Dashboard';
import { AuthProvider } from './Auth/AuthProvider';
import ForgotPassword from './pages/permissions/ForgotPassword';
import ResetPassword from './pages/permissions/ResetPassword';
import AcademicInterface from './routes/Academic';
import GreenhouseInterface from './routes/Greenhouse';
import EstudentGrade from './pages/academic/EstudentGrade';
import EstudentActivityGrade from './pages/academic/EstudentActivityGrade';
import ProfilePage from './routes/ProfilePage';

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <AuthProvider>
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<ProfilePage />} />
        <Route path='/hola' element={<Wellcome />} />
        <Route path='/login' element={<Login />} />
        <Route path='/signup' element={<Signup />} />
        <Route path='/signup/:token' element={<Signup />} />
        <Route path='/forgotpassword' element={<ForgotPassword />} />
        <Route path='/resetpassword/:token' element={<ResetPassword />} />
        <Route path='/dashboard/*' element={<Dashboard />} />
        <Route path='/academic/*' element={<AcademicInterface />} />
        <Route path='/academic/estudentgrade/:clave/:code' element={<EstudentGrade />} />
        <Route path='/academic/estudentactivitygrade/:clave/:student/:activity' element={<EstudentActivityGrade />} />

        <Route path='/greenhouse/*' element={<GreenhouseInterface />} />
        
      </Routes>
    </BrowserRouter>
  </AuthProvider>
);
